export default "Exonération CSPE & taux réduits d'accise — Électro-intensifs | Solution Éco France";
